import apiClient from "../_service/BaseService";
import { AxiosResponse } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { URL } from "../config";

const getPayrun = async (id: number) =>
  apiClient.get(URL.GET_PAYRUN, {
    params: {
      company: id,
    },
  });

const getPayrunByCompany = async (id: number | string) =>
  apiClient.get(URL.GET_PAYRUN_BY_COMPANY + `${id}`);

const usePayrun = (
  id: number | string,
): UseQueryResult<AxiosResponse<any, any>> =>
  useQuery("payrun", () => getPayrunByCompany(id));

export default usePayrun;
